<template>
  <!-- <div>
    <v-expansion-panels
      accordion
      :multiple="false"
      popout> -->
      <v-expansion-panel>
        <HTTPresponse :alert="httpalert" @changeHTTPBoxState="HTTPState"></HTTPresponse>
        <v-expansion-panel-header>
          <v-row wrap>
              <span class="triangle"></span>
              <v-divider vertical class="ml-5 mr-2"></v-divider>
            <v-col cols="12" md="4" align-self="center">
              <v-layout column justify-start align-start>
                <h3 class="mw-100" v-html="survey.title"></h3>
                <h4
                  v-if="rootSurvey"
                  v-html="rootSurvey.info[`title_${$i18n.locale}`]"></h4>
              </v-layout>
            </v-col>
            <!-- <v-spacer></v-spacer> -->
              <v-spacer></v-spacer>
              <v-divider vertical></v-divider>
              <v-spacer></v-spacer>
            <!-- <v-spacer></v-spacer> -->
            <v-col cols="12" md="2" align-self="center">
              <v-layout column justify-center align-center>
                <template v-if="rootSurvey">
                  <!-- <pre>TOTAL : {{rootSurvey.total}}</pre>
                  <pre>DONE : {{rootSurvey.done}}</pre> -->
                  <ProgressGauge
                    :size="60"
                    :status="rootSurvey.info.status"
                    :score="parseInt(rootSurvey.done.point)"
                    :scoreRequired="parseInt(rootSurvey.total.requiredpt)"
                    :question="parseInt(rootSurvey.done.question)"
                    :mandatoryq="parseInt(rootSurvey.done.mandatoryq)"
                    :mandatoryqRequired="parseInt(rootSurvey.total.mandatoryq)"
                  ></ProgressGauge>
                </template>
                <ProgressGauge v-else></ProgressGauge>
                <!-- <pre v-if="rootSurvey">{{rootSurvey}}</pre> -->
              </v-layout>
            </v-col>

              <v-spacer></v-spacer>
              <v-divider vertical></v-divider>
              <v-spacer></v-spacer>

            <v-col cols="12" md="5" align-self="center">
              <v-layout row justify-center align-center>
                <template v-if="rootSurvey">
                  <!-- <pre>{{rootSurvey}}</pre> -->
                  <ProgressRing
                    :progress="parseInt(rootSurvey.done.point)"
                    :objectif="parseInt(rootSurvey.total.point)"
                    :minimum="parseInt(rootSurvey.total.requiredpt)"
                    :mandatoryq="parseInt(rootSurvey.done.mandatoryq)"
                    :requiredmandatoryq="parseInt(rootSurvey.total.mandatoryq)"
                    tooltip
                  ></ProgressRing>
                </template>
                <ProgressRing v-else></ProgressRing>

                <v-divider vertical class="mx-10 mx-xl-3"></v-divider>

                <template v-if="rootSurvey">
                  <ProgressRing
                    :progress="parseInt(rootSurvey.done.question)"
                    :objectif="parseInt(rootSurvey.total.question)"
                    :minimum="parseInt(rootSurvey.total.requiredpt)"
                    :mandatoryq="parseInt(rootSurvey.done.mandatoryq)"
                    :requiredmandatoryq="parseInt(rootSurvey.total.mandatoryq)"
                    :progressquestion="parseInt(rootSurvey.done.question)"
                    :questioncount="parseInt(rootSurvey.total.question)"
                    question
                    tooltip
                  ></ProgressRing>
                </template>
                <ProgressRing v-else></ProgressRing>
              </v-layout>
            </v-col>
          </v-row>
          <template v-slot:actions>
            <v-icon></v-icon>
          </template>
        </v-expansion-panel-header>

        <v-expansion-panel-content class="pl-0 pl-md-5 mt-10 mt-md-0" style="position: relative;">
          <div class="actions d-flex align-center justify-space-between">
            <!-- Show final report only if you get the required point -->
            <!-- <template v-if="rootSurvey">
              <router-link
                :class="parseInt(rootSurvey.done.point) >= parseInt(rootSurvey.total.requiredpt) &&
                      parseInt(rootSurvey.done.mandatoryq) == parseInt(rootSurvey.total.mandatoryq) ? 'link mr-3' : 'link mr-3 disabled'"
                :to="{
                  name: 'final-report',
                  params: {
                  answerid: survey.id,
                  sequenceid: survey.surveyid,
                  firmid: firm.id
                }}"
              >{{ $t('dashboard-screen.link-1') }}</router-link>
            </template> -->

            <!-- Edit btn -->
            <template v-if="rootSurvey">
              <!-- {{$t('dashboard-screen.link-1')}}
              {{$t('dashboard-screen.link-2')}} -->
              <router-link
                :class="'link mr-3'"
                :to="{
                  name: 'edit-audit',
                  params: {
                  answerid: survey.id,
                  sequenceid: survey.surveyid,
                  firmid: firm.id
                }}"
              >{{ rootSurvey.info.status !== 'sent' &&
                  rootSurvey.info.status !== 'verify' &&
                  rootSurvey.info.status !== 'success' &&
                  rootSurvey.info.status !== 'failed' ?
                  $t('dashboard-screen.link-2') : $t('dashboard-screen.link-1') }}</router-link>
            </template>

            <!-- <button class="link disabled mr-3">{{ $t('dashboard-screen.link-3') }}</button> -->

            <!-- Delete btn -->
            <template v-if="rootSurvey">
              <button
                :class="rootSurvey.info.status !== 'sent' &&
                        rootSurvey.info.status !== 'verify' ? 'link mr-3' : 'link mr-3 disabled'"
                @click="dialog = true">{{ $t('dashboard-screen.link-4') }}</button>
            </template>

            <!-- PDF btn -->
            <template v-if="rootSurvey">
              <ExportModal
                :survey="rootSurvey"
                :answerid="survey.id"
                :firm="firm"
                :sequenceid="survey.surveyid"></ExportModal>
            </template>

            <!-- Delete dialog box -->
            <v-dialog
              v-model="dialog"
              max-width="500"
            >
              <v-card class="ma-0">
                <v-card-title class="headline">
                  <div class="headline" v-html="`${$t('dashboard-screen.dialog.title')} ${survey.title}`"></div>
                </v-card-title>

                <v-card-text>{{ $t('dashboard-screen.dialog.description') }}</v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    rounded
                    text
                    color="error"
                    @click="dialog= false"
                  >
                    {{ $t('dashboard-screen.dialog.btn-1') }}
                  </v-btn>
                  <v-btn
                    outlined
                    rounded
                    color="primary"
                    @click="deleteAudit(survey.id)"
                  >
                    {{ $t('dashboard-screen.dialog.btn-2') }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>

          <v-layout
            d-block
            d-md-flex
            row
            ma-0
            justify-space-between
            class="mb-12 mb-md-0"
          >
            <v-flex xs12 md7 pr-0 pr-md-3>
              <template v-if="rootSurvey && sequences.length > 0">
                <!-- <v-skeleton-loader
                  :loading="sequences .length > 0 ? false  : true"
                  transition="scale-transition"
                  type="list-item-two-line"
                > -->
                  <TotalAuditProgression :sequences="sequences" :rootSurvey="rootSurvey" :answerid="survey.id" :sequenceid="survey.surveyid" :firmid="firm.id"></TotalAuditProgression>
                <!-- </v-skeleton-loader> -->
              </template>
            </v-flex>

            <v-spacer></v-spacer>

            <v-flex xs12 md5 pl-0 pl-md-3>
              <template v-if="sequences">
                <RelatedQuestionOverview :sequences="sequences" :keywords="survey.surveyid" class="mb-4"></RelatedQuestionOverview>
              </template>

              <template v-if="rootSurvey && rootSurvey.unanswered_mandatory && rootSurvey.unanswered_mandatory.length > 0">
                <UnansweredQuest :questions="rootSurvey.unanswered_mandatory" :sequenceid="survey.surveyid" :firmid="firm.id" :answerid="survey.id"></UnansweredQuest>
                <!-- <UnansweredCrit :answerid="survey.id"></UnansweredCrit> -->
              </template>
            </v-flex>
          </v-layout>

        </v-expansion-panel-content>
      </v-expansion-panel>
    <!-- </v-expansion-panels>
  </div> -->
</template>

<script>
import { showSequence } from '@/js/survey/showSequence'
import { deleteSurvey } from '@/js/survey/deleteSurvey'
import ProgressGauge from '@/components/progress/ProgressGauge'
import ProgressRing from '@/components/progress/ProgressRing'
import TotalAuditProgression from '@/components/audits/progression/TotalAuditProgression'
import RelatedQuestionOverview from '@/components/audits/RelatedQuestionOverview'
import ExportModal from '@/components/audits/ExportModal'
import UnansweredQuest from '@/components/audits/UnansweredQuest'
// import UnansweredCrit from '@/components/audits/UnansweredCrit'
import HTTPresponse from '@/components/app/HTTPresponse'

export default {
  components: {
    ProgressGauge: ProgressGauge,
    ProgressRing: ProgressRing,
    TotalAuditProgression: TotalAuditProgression,
    RelatedQuestionOverview: RelatedQuestionOverview,
    ExportModal: ExportModal,
    UnansweredQuest: UnansweredQuest,
    // UnansweredCrit,
    HTTPresponse: HTTPresponse
  },

  props: {
    survey: Object,
    firm: Object
  },

  data () {
    return {
      rootSurvey: null,
      dialog: false,
      sequences: [],
      httpalert: false,

      loading: true
    }
  },

  methods: {
    deleteAudit (surveyid) {
      // if (!this.$store.getters['auth/isAuthenticated']) return

      const params = {
        surveyid: surveyid,
        key: this.$store.state.auth.token
      }
      deleteSurvey(params)
        .then(response => {
          this.$emit('deleteSurveyToParent')
          this.dialog = false
        })
        .catch(() => {
          this.httpalert = true
          setTimeout(() => {
            this.httpalert = false
          }, 4000)
        })
    },

    HTTPState (value) {
      this.httpalert = this.value
    }
  },

  mounted () {
    this.$root.$on('disableInterceptor')
  },

  async created () {
    // if (!this.$store.getters['auth/isAuthenticated']) return

    const params = {
      answerid: this.survey.id,
      path: '',
      sequenceid: this.survey.surveyid,
      key: this.$store.state.auth.token
    }
    await showSequence(params)
      .then(async response => {
        this.rootSurvey = response

        for (var i = 0, len = this.rootSurvey.sequences.length; i < len; i++) {
          const params = {
            answerid: this.survey.id,
            path: this.rootSurvey.sequences[i].path,
            sequenceid: this.rootSurvey.sequences[i].id,
            key: this.$store.state.auth.token
          }
          this.$root.$on('enableInterceptor')
          await showSequence(params)
            .then(response => {
              // console.log('ici', response)
              this.sequences.push(response)
              this.$root.$on('enableInterceptor')
            })
            .catch(() => {
              this.httpalert = true
              setTimeout(() => {
                this.httpalert = false
              }, 4000)
              this.$root.$on('enableInterceptor')
            })
        }
      })
      .catch(() => {
        this.httpalert = true
        setTimeout(() => {
          this.httpalert = false
        }, 4000)
        this.$root.$on('enableInterceptor')
      })

    // // Init: Get all the first sequences lvl
    // this.rootSurvey.sequences.forEach(async (sequence) => {
    //   const params = {
    //     answerid: this.answerid,
    //     path: sequence.path,
    //     sequenceid: sequence.id,
    //     key: this.$store.state.auth.token
    //   }
    //   await showSequence(params)
    //     .then(response => {
    //       this.sequences.push(response)
    //     })
    //     .catch(error => {
    //       console.log(error)
    //     })
    // })
  }
}
</script>

<style lang="scss" scoped>
@import '../../styles/components/audits/audit-overview';

.actions {
  position: absolute;
  top: -32px; left: 65px;
}
</style>
